<div
	class="edit-request-container au-forms"
	[class.full-height]="!request"
	[class.fullscreen]="isFullscreen$ | async"
>
	@if (request) {
		<ng-container>
			<div class="edit-name">
				<au-cmms-entity-name
					[name]="request.name"
					(inputBlur)="editRequest($event)"
					(controlReady)="addChildControl('name', $event)"
					namePreviewClasses="m-b-sxs"
				>
				</au-cmms-entity-name>

				<div
					class="icon-wrapper"
					matRipple
					matRippleColor="rgba(#1c4b31, 0.05)"
					[matRippleCentered]="true"
					[matMenuTriggerFor]="deleteBtnMenu"
				>
					<mat-icon class="secondary-text-icon"> more_vert </mat-icon>
				</div>

				<mat-menu #deleteBtnMenu="matMenu" xPosition="before" class="actions-menu">
					<button mat-menu-item (click)="requestDeleteBtnHandler()">
						<mat-icon class="critical-icon" svgIcon="delete"></mat-icon>
						<span class="button-delete"
							>{{ 'delete' | translate }} {{ 'request' | translate }}</span
						>
					</button>
				</mat-menu>
			</div>

			<div id="General" class="row-container m-b-xs">
				<div class="created-by">
					<span class="label">{{ 'created' | translate }}</span>
					<au-avatar-with-name [data]="request.createdBy"> </au-avatar-with-name>
					<span class="body-2 grey">{{ request.created | dateAgo }}</span>
				</div>

				<cmms-entity-status
					[status]="request.status"
					[statuses]="requestStatuses"
					(updateStatus)="editRequest($event)"
				>
				</cmms-entity-status>
			</div>
			<div class="m-b-xs requester">
				<span class="select-label">{{ 'requester' | translate }}</span>
				<cmms-autocomplete-contact
					namePreviewClasses="m-b-sxs"
					[requestees]="request.requestees"
					[comments]="request.comments"
					[editMode]="false"
					[placeholder]="request.requestees[0] ? request.requestees[0].name : ''"
					(requesteesChanged)="requesteesChanged($event)"
				/>
			</div>

			<div>
				<cmms-locations-section
					[locationsInputList]="request.locations"
					(locationsChanged)="locationsChanged($event)"
				></cmms-locations-section>
			</div>

			<attach-new-quick-entity
				[parentEntityData]="request"
				[shownActions]="[EntityType.INCIDENT, EntityType.WORK_ORDER]"
				(createdEntity)="reloadRequests()"
			/>

			<image-section
				(addExistingFileClicked)="navigateToExist($event)"
				[files]="attachedFiles"
			/>

			<div class="priority-and-category">
				<cmms-priority-level
					class="priority"
					[priorityLevel]="request.priority"
					(priorityLevelChanged)="editRequest($event)"
				></cmms-priority-level>

				<cmms-entity-category
					class="category"
					[selectedCategory]="request.category"
					(categoryChanged)="editRequest($event)"
				></cmms-entity-category>
			</div>

			<div class="assignee-section m-b-sm">
				<cmms-assignee-and-approver
					[approver]="request.approver"
					[assignee]="request.assignee"
					(assigneeUpdate)="assigneeUpdate($event)"
					(approverUpdate)="approverUpdate($event)"
				></cmms-assignee-and-approver>
			</div>

			<div class="m-b-m">
				<cmms-labels-section
					[labelsList]="request.labels"
					(labelsListChanged)="editRequest($event)"
				/>
			</div>

			<div class="description m-b-m">
				<cmms-description
					[textModeEnabled]="true"
					[isRequired]="false"
					[description]="request.description"
					(descriptionBlur)="editRequest($event)"
				></cmms-description>
			</div>

			<div id="Attachments" class="sections">
				<entity-section
					[entityType]="cmmsPages.editIncident"
					(addNewEntityItem)="navigateTo($event)"
					(addExistingEntityItem)="navigateToExist($event)"
					[tableData]="attachedIncidents"
					[tableColumns]="tableConfig"
					(unlink)="unlinkIncident($event.data)"
					(rowSelect)="viewSelected($event)"
				>
				</entity-section>
				<entity-section
					[entityType]="cmmsPages.editWorkOrder"
					(addNewEntityItem)="navigateTo($event)"
					(addExistingEntityItem)="navigateToExist($event)"
					[tableData]="attachedWO"
					[tableColumns]="tableConfig"
					(unlink)="unlinkWorkOrder($event.data)"
					(rowSelect)="viewSelected($event)"
				>
				</entity-section>
				<assets-section
					(openAssets)="openAssets()"
					(newAsset)="navigateTo($event)"
					(rowSelect)="viewSelected($event.data)"
					[assets]="attachedAssets"
					(unlink)="unlinkAsset($event.data)"
				>
				</assets-section>
			</div>

			<div id="Files" class="sections">
				<au-file-loader
					[loadedFiles]="attachedFiles"
					[options]="{ fileTypesConfig }"
					[delegateDeleting]="true"
					[askDeleting]="false"
					[cardsView]="true"
					(controlReady)="addChildControl('files', $event)"
					(addExistingFileClicked)="navigateToExist($event)"
					(filesLoaded)="filesUpdates($event)"
					(filesDeleted)="filesDeleted($event)"
					(rowSelect)="viewSelected($event)"
				></au-file-loader>
			</div>

			<div id="Other" class="comments m-t-m">
				<au-comments
					[commentsList]="request.comments"
					[requester]="request.requestees"
					[isRequest]="true"
					(deleteComment)="deleteCommentConfirmation($event)"
					(editComment)="editComment($event)"
				></au-comments>
			</div>
			<div class="type-comment">
				<comment-input
					[request]="request"
					(commentSubmitted)="submitComment($event)"
					(newEntityClicked)="newEntityFromComment($event)"
				/>
			</div>
		</ng-container>
	} @else {
		<div class="spinner-wrapper">
			<mat-spinner diameter="60"></mat-spinner>
		</div>
	}
</div>
